/**
 * Campos de negocio que genera table_metadata_generator (modo "columns",
 * ver bedrock_metadata_generator.py::_build_prompt en
 * whisperbi-back-semantic-model) y cómo se agrupan por finalidad para
 * mostrarse en el diálogo de override de actualización
 * (MetadataOverridePreviewDialog) -- nunca incluye campos técnicos
 * (column_name, data_type, is_primary_key, etc.), esos no los genera la IA.
 *
 * `formKey` es el campo real del estado del formulario
 * (SemanticTableFormDialog::createDefaultColumn) donde vive cada valor --
 * los campos de lista se guardan como texto separado por comas
 * (`*Text`), no como array, por eso difieren del nombre que devuelve la
 * IA (`synonyms` -> `synonymsText`, etc.).
 */

export const AI_TABLE_FIELDS = [
  { key: 'display_name', label: 'Nombre para mostrar' },
  { key: 'description', label: 'Descripción' }
];

export const AI_FIELD_LABELS = {
  business_name: 'Nombre de negocio',
  semantic_role: 'Rol semántico',
  semantic_type: 'Tipo semántico',
  description: 'Descripción',
  synonyms: 'Sinónimos',
  example_values: 'Valores de ejemplo',
  usage_notes: 'Notas de uso',
  usage_constraints: 'Restricciones de uso',
  domain: 'Dominio',
  pattern: 'Patrón',
  unit: 'Unidad',
  aggregation: 'Agregación',
  temporal_behavior: 'Comportamiento temporal',
  time_grain: 'Granularidad temporal'
};

export const AI_FIELD_TO_FORM_KEY = {
  business_name: 'business_name',
  semantic_role: 'semantic_role',
  semantic_type: 'semantic_type',
  description: 'description',
  synonyms: 'synonymsText',
  example_values: 'exampleValuesText',
  usage_notes: 'usageNotesText',
  usage_constraints: 'usageConstraintsText',
  domain: 'domain',
  pattern: 'pattern',
  unit: 'unit',
  aggregation: 'aggregation',
  temporal_behavior: 'temporal_behavior',
  time_grain: 'time_grain'
};

export const AI_LIST_FIELDS = new Set(['synonyms', 'example_values', 'usage_notes', 'usage_constraints']);

export const AI_FIELD_GROUPS = [
  {
    key: 'identification',
    label: 'Identificación semántica',
    fields: ['business_name', 'semantic_role', 'semantic_type']
  },
  {
    key: 'documentation',
    label: 'Documentación',
    fields: ['description', 'synonyms', 'example_values']
  },
  {
    key: 'usage_rules',
    label: 'Reglas de uso',
    fields: ['usage_notes', 'usage_constraints', 'domain']
  },
  {
    key: 'format_aggregation',
    label: 'Formato y agregación',
    fields: ['pattern', 'unit', 'aggregation', 'temporal_behavior', 'time_grain']
  }
];

/** Todos los campos de columna que la IA puede proponer, en el orden de los grupos. */
export const AI_COLUMN_FIELDS = AI_FIELD_GROUPS.flatMap((group) => group.fields);
